var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeHidden({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 5.33203L13.1717 13.1703M26.6667 26.6654L18.8285 18.8271M13.1717 13.1703C12.4478 13.8941 12.0001 14.8941 12.0001 15.9987C12.0001 18.2078 13.7909 19.9987 16.0001 19.9987C17.1047 19.9987 18.1047 19.551 18.8285 18.8271M13.1717 13.1703L18.8285 18.8271M9.02437 9.02298C6.30466 10.7974 3.95179 13.3667 2.66675 15.9984C4.99536 20.7673 10.8294 25.332 15.9998 25.332C18.3168 25.332 20.7672 24.4153 22.9757 22.9743M13.0153 7.12826C14.0153 6.82958 15.02 6.66536 16.0007 6.66536C21.171 6.66536 27.0042 11.2307 29.3334 15.999C28.5974 17.5056 27.5116 18.9919 26.2073 20.3203",
    stroke: "#201E24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHidden);
export default __webpack_public_path__ + "static/media/eye-hidden.1d21584e8f45dd26aad316e21c1c38e2.svg";
export { ForwardRef as ReactComponent };